class BSSearch extends HTMLElement
{
    #initialized = false;
    #input = null;

    connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.innerHTML = `
            <div id="bs-search__wrapper">
                <span class="icon icon--search" aria-hidden="true"></span>
                <input type="text" placeholder="Type to search..." name="search" autocomplete="off">
                <button class="button button--hoverless button--borderless button--no-background" type="button">
                    <span class="icon icon--remove" aria-hidden="true"></span>
                </button>            
            </div>
        `;
    }
}

customElements.define('bs-search', BSSearch);